import { motion } from "framer-motion";
import { SubMotionProps } from "../../types";

export default function PageMotion({ children, style, className }: SubMotionProps) {
    return (
        <motion.div
            variants={{
                initial: {
                    x: '-100vw',
                },
                final: {
                    x: "0vw",
                    transition: {
                        type: "tween",
                        mass: 0.5,
                    }
                }
            }}
            initial="initial"
            animate="final"
            style={style}
            className={className}
        >
            {children}
        </motion.div>
    )
}

